// extracted by mini-css-extract-plugin
export default {"image":"X2-z","loaded":"Y2-z"};